import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from './client';

// Server: notifications/NotificationPrefsDto.java. `available` is false for every category on a
// minor-band account regardless of that category's own minor_allowed flag — the client greys the
// toggle out rather than pretending it does anything.
export type CategoryPrefDto = {
  code: string;
  label: string;
  enabled: boolean;
  available: boolean;
};

export type NotificationPrefsDto = {
  pushEnabled: boolean;
  categories: CategoryPrefDto[];
};

export const notifPrefsKeys = {
  all: ['notificationPrefs'] as const,
};

export const getNotificationPrefs = () => apiFetch<NotificationPrefsDto>('/notifications/prefs');

export function useNotificationPrefs() {
  return useQuery({ queryKey: notifPrefsKeys.all, queryFn: getNotificationPrefs });
}

export type SetPrefInput = {
  category: string;
  enabled: boolean;
};

export const putNotificationPref = (input: SetPrefInput) =>
  apiFetch<NotificationPrefsDto>('/notifications/prefs', { method: 'PUT', body: JSON.stringify(input) });

// Not a currency action — invalidate on success and let the next GET pick up the server's own
// resulting state (mirrors useSetActive's shape: no onMutate, single invalidate on success).
export function useSetPref() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: putNotificationPref,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notifPrefsKeys.all }),
  });
}
